import safeStringify from "fast-safe-stringify";
import { decode } from "jsonwebtoken";

export async function setToken(token) {
  if (token === undefined) return null;
  await localStorage.setItem("token", safeStringify(token));
}

export function getToken() {
  return JSON.parse(localStorage.getItem("token"));
}

export async function removeToken() {
  await localStorage.removeItem("token");
}

export const isValidToken = (token) => {
  if (!token) return false;
  const expr = decode(token).exp;
  const date = new Date().getTime() / 1000 + 50;
  return expr > date;
};

export async function getUserId() {
  const token = await getToken();
  const decodedToken = decode(token);
  return decodedToken ? decodedToken.id : null;
}

export const setReportToken = (token) => {
  if (!token) return;
  const safeToken = encodeURIComponent(token);
  document.cookie = [
    `reportToken=${safeToken}`,
    `path=/`,
    `max-age=${60 * 60 * 24}`, // 1 day
    `SameSite=Strict`,
    `Secure`,
  ].join("; ");
};

export const getReportToken = () => {
  const match = document.cookie.match(/(?:^|; )reportToken=([^;]+)/);
  if (!match) return null;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return null;
  }
};
